// src/utils/patientReportData.js
//
// Everything the patient-view report needs for one triage result: the newest result row of its health record, the record itself (draw date,
// lab), the earlier draws and the health journey. Shared by the report page (PatientTriageReportPage) and the chat download, so both
// show the same report.
import { healthRecordAPI, healthJourneyAPI } from '../services/api';
import { priorDraws } from './triageUtils';

/** Rejects when the result or its record cannot be loaded; only the journey is optional (null). */
export async function loadPatientReport(patientId, triageId) {
  const all = (await healthRecordAPI.getTriageHistory(patientId)).data || [];
  const requested = all.find(r => r.id === triageId);
  if (!requested) throw new Error('Result not found');
  // A re-run saves a new row for the same record; always show the newest one.
  const result = requested.healthRecordId
    ? all.filter(r => r.healthRecordId === requested.healthRecordId)
        .reduce((a, b) => (new Date(b.createdAt) > new Date(a.createdAt) ? b : a), requested)
    : requested;
  const [recordRes, journey] = await Promise.all([
    healthRecordAPI.get(patientId, result.healthRecordId),
    healthJourneyAPI.get(patientId).then(r => r?.data ?? null).catch(() => null),
  ]);
  const record = recordRes.data;
  // The draws just before THIS report, not the newest overall.
  const history = priorDraws(
    all.filter(t => t.healthRecordId !== result.healthRecordId),
    result, record?.drawDate || result.drawDate || result.createdAt,
  ).slice(0, 8);
  return { result, record, history, journey };
}
